<template>
  <v-responsive
    aspect-ratio=".611"
    style="width: 100%; margin: auto; max-width: calc(100vw - 12px)"
  >
            <!-- مودال کیوآر -->
        <universal-qr-modal
          v-model="showQrDialog"
          :title="data.visitName || 'کارت ویزیت'"
          :subtitle="'برای دریافت اطلاعات، کیوآر زیر را اسکن کنید.'"
          :identifier="data?.identifier || ''"
          :profile-avatar="data.photo?.profile || ''"
          :primary-color="primaryActionColor"
          :svg-data="qrSvgDataUrl"
        />
        <!-- دکمه شناور اسکن QR -->
        <v-btn
          fab
          x-small
          elevation="4"
          class="qr-floating-btn"
          title="مشاهده و اسکن کیوآر کد"
          @click="showQrDialog = true"
        >
          <v-icon size="18">mdi-qrcode-scan</v-icon>
        </v-btn>


    <component
      :is="components[data?.photo?.transition || 'scale']"
      mode="out-in"
      origin="center"
    >
      <div
        v-if="showWelcome && data?.photo?.hasWelcome"
        key="loading"
        class="col-md-11 mx-auto elevation-3 d-flex"
        style="min-height: 80vh"
      >
        <div v-if="data?.photo?.welcome === ''" class="col m-auto">
          <atom-spinner
            :animation-duration="1000"
            :size="80"
            class="mx-auto justify-content-center"
            color="#ff1d5e"
          />
        </div>
        <div
          v-if="data?.photo?.welcome && data?.photo?.welcome !== ''"
          class="m-auto"
        >
          <img
            :src="data.photo.welcome"
            alt=""
            class="bg-white rounded-circle mx-auto my-auto"
            width="100"
          />
        </div>
      </div>

      <div
        v-else-if="locationPage && data?.coordinates"
        key="location"
        class="col-md-12 elevation-3"
      >
        <v-card-title class="px-0 pt-0 justify-end">
          <v-btn
            class="mx-2 mr-auto text-left"
            color="white"
            small
            @click="locationPage = false"
          >
            {{ localI18n.t("back") }}
            <v-icon class="ms-2" color="black">mdi-keyboard-backspace</v-icon>
          </v-btn>
        </v-card-title>

        <div>
          <p>
            <span class="fa fa-car ml-1 text-danger"></span>
            {{ localI18n.t("after_click_location") }}
          </p>

          <v-card
            v-if="locLoading"
            class="d-flex align-center justify-center"
            flat
            height="400"
            width="100%"
          >
            <atom-spinner
              :animation-duration="1000"
              :size="120"
              class="mx-auto justify-content-center"
              color="#ff1d5e"
            />
          </v-card>

          <mapir
            v-if="data?.apiKey && data?.coordinates"
            :apiKey="data.apiKey"
            :center="data.coordinates"
            :zoom="17"
            class="col-md-12"
            style="width: 100%; height: 400px"
            @click.self="openMap"
          >
            <mapNavigationControl position="top-right" />
            <mapMarker
              v-if="data?.coordinate"
              :coordinates.sync="data.coordinates"
              color="red"
              kind="marker"
              readonly
            >
              <template v-slot:marker>
                <v-icon>mdi-map-marker</v-icon>
              </template>
            </mapMarker>
          </mapir>
        </div>

        <div class="col-md-12 flex py-2 my-3">
          <p>
            <span><v-icon color="red">mdi-map-marker</v-icon></span
            >{{ data?.address }}
          </p>
        </div>
      </div>
      <!-- Language Sheet -->

      <!-- v-card اصلی -->
      <v-card
        key="theme"
        :class="expand ? 'expanded' : 'contracted'"
        class="content-holder"
        flat
        height="100%"
        min-height="80vh"
      >
        <v-responsive
          :aspect-ratio="expand ? '.673' : '1'"
          :style="{ background: data?.pallete?.bodyColor||'linear-gradient(to top left , #006064FF, #03A9F4FF)' }"
          class="header-img-container"
        >
          <transition mode="out-in" name="fade-head-img">
            <img
              v-if="(expand || !data?.photo?.profile) && getHeaderImg"
              key="back"
              :src="getHeaderImg"
              alt=""
              class="header-img-bg"
            />
            <div
              v-else-if="getHeaderImg"
              key="logo"
              class="white rounded-circle header-img-bg"
            >
              <div
                :style="{ backgroundImage: `url(${getHeaderImg})` }"
                class="bg-filter"
              />
              <img :src="getHeaderImg" alt="" />
            </div>
          </transition>
        </v-responsive>

        <div
          id="header-name"
          :style="{
            background: data?.pallete?.headColor||'linear-gradient(to top left , #00BCD4FF, #2F0743FF)',
            color: data?.pallete?.textColor||'#ffffff',
          }"
          class="sticky-name-holder"
        >
          <div>
            <v-card-title
              class="py-2 ms-1 font-size-h4 font-weight-bold text-break"
              v-text="data?.organizationName"
            />
            <v-card-text class="font-size-h6">
              <v-icon :color="data?.pallete?.textColor||'#ffffff'" small>mdi-star</v-icon>
              {{ data?.subOrgan }}
            </v-card-text>
          </div>

          <v-menu
            :bottom="!expand"
            :top="expand"
            offset-y
            right
            v-model="mainMenu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="data?.pallete?.textColor||'#ffffff'"
                :loading="vcfLoading"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list
              :style="{ background: data?.pallete?.headColor||'linear-gradient(to top left , #00BCD4FF, #2F0743FF)' }"
              dark
              dense
            >
              <!-- Language Change Item in Main Menu -->
              <v-list-item
                v-if="availableLangs.length > 1"
                class="language-trigger-item pl-0"
                @click.stop.prevent="
                  {
                    langMenu = !langMenu;
                    mainMenu = !mainMenu;
                  }
                "
              >
                <v-menu
                  v-model="langMenu"
                  :close-on-content-click="false"
                  transition="slide-x-transition"
                  allow-overflow
                  :bottom="!expand"
                  :top="expand"
                  offset-x
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn small text v-bind="attrs" v-on="on">
                      <v-icon small :style="{ color:data.pallete.textColor}">mdi-chevron-right</v-icon>
                      <v-list-item-icon>
                        <v-icon :style="{ color:data.pallete.textColor}">mdi-translate</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title :style="{ color:data.pallete.textColor}">
                          {{ localI18n.t("language.change_language") }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-btn>
                  </template>

                  <LanguageSwitcherList
                    :currentLang="currentLang"
                    :headColor="data?.pallete?.headColor||'linear-gradient(to top left , #00BCD4FF, #2F0743FF)'"
                    :textColor="data?.pallete?.textColor ||'#ffffff'"
                    @source-changed="handleLangChange"
                  />
                </v-menu>
              </v-list-item>

              <v-list-item :href="`tel:${data.companyNumber}`">
                <v-list-item-icon>
                  <v-icon :style="{ color:data.pallete.textColor}">mdi-phone</v-icon>
                </v-list-item-icon>
                <v-list-item-title :style="{ color:data.pallete.textColor}">{{
                  localI18n.t("phone_number")
                }}</v-list-item-title>
              </v-list-item>

              <v-list-item
                v-if="data?.coordinates"
                @click="locationPage = true"
              >
                <v-list-item-icon>
                  <v-icon :style="{ color:data.pallete.textColor}">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-title :style="{ color:data.pallete.textColor}">{{
                  localI18n.t("location")
                }}</v-list-item-title>
              </v-list-item>

              <v-list-item v-if="data?.customerClub && (data.customerClub.configs?.isActive || data.customerClub.title?.trim() || data.customerClub.description?.trim())">
                <v-list-item-icon>
                  <v-icon :style="{ color:data.pallete.textColor}">mdi-card-account-phone-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title :style="{ color:data.pallete.textColor}">{{
                  localI18n.t("customer_club")
                }}</v-list-item-title>
              </v-list-item>

              <v-list-item
                v-if="
                  (data?.phoneNumber &&
                    data?.phoneNumber?.length > 0 &&
                    data?.phoneNumber?.[0]?.number) ||
                  data?.companyNumber
                "
                @click="getVcf"
              >
                <v-list-item-icon>
                  <v-icon :style="{ color:data.pallete.textColor}">mdi-plus</v-icon>
                </v-list-item-icon>
                <v-list-item-title :style="{ color:data.pallete.textColor}">{{
                  localI18n.t("save_contact")
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <v-btn
          :style="{
            background: data?.pallete?.headColor||'linear-gradient(to top left , #00BCD4FF, #2F0743FF)',
            color: data?.pallete?.textColor||'#ffffff',
            top: expand ? '' : `${topAction}px`,
          }"
          absolute
          class="px-0 rounded-pill btn-action"
          depressed
          large
          min-width="44"
          top
          @click="expand = !expand"
        >
          <transition mode="out-in" name="expand-btn">
            <v-icon v-if="!expand" key="close" :style="{ color:data.pallete.textColor}">mdi-chevron-left</v-icon>
            <v-icon v-else key="open" :style="{ color:data.pallete.textColor}">mdi-menu</v-icon>
          </transition>
        </v-btn>

        <div
          class="main-wrapper"
          :class="[
            data.pallete.themePattern ? `bg-${data.pallete.themePattern}` : '',
            isCurrentLangRTL ? 'dir-rtl' : 'dir-ltr'
          ]"
          :style="{
            direction: currentTextDirection
          }"
        >
          <div
            class="pt-4"
            :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
          >
            <drag-list v-model="draggingKeys">
              <template v-slot:default="{ item }">
                <template v-if="item === 'userName'">
                  <p
                    v-if="data?.userName"
                    class="my-2"
                    :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                    :dir="getTextDirectionFromContent(data.userName)"
                    :style="{
                      textAlign: getTextAlignFromContent(data.userName),
                    }"
                  >
                    <v-icon>mdi-account-outline</v-icon>
                    : {{ data?.userName }}
                  </p>
                </template>

                <template v-else-if="item === 'workField'">
                  <p
                    v-if="data?.workField"
                    class="my-2"
                    :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                    :dir="getTextDirectionFromContent(data.workField)"
                    :style="{
                      textAlign: getTextAlignFromContent(data.workField),
                    }"
                  >
                    <v-icon>mdi-briefcase-account</v-icon>
                    : {{ data?.workField }}
                  </p>
                </template>
                <!-- pdfSection -->
                <template v-if="item === 'pdf'">
                  <div v-if="data?.pdf && data?.pdf?.length > 0" class="box">
                      <pdf-preview-display
                        :pdf-data="data.pdf"
                        :layout-mode="layoutPreference"
                        :pdf-selector="data.pdfSelector"
                        :current-lang="currentLang"
                        :lang="currentLang"                     

                      />
                    </div>
                </template>
                <!--consultation-->
                <template v-if="item==='consultation'">
                  <consultation-new-show class="box pa-0 ma-0"
                    :style="{
                      background: data.consultationNew?.sectionColor?.backGround,
                      color: data.consultationNew?.sectionColor?.text,
                    }"
                    :color="data.consultationNew?.sectionColor?.text"
                    v-model="data.consultationNew"
                    :current-lang="currentLang"
                    :lang="currentLang"                     

                  />
                </template>
                <!--feedback-->
                <template v-if="item==='FeedBack'" >
                  <b-feedback-view style="width: 97% !important;"
                      v-if="data.FeedBack && data.FeedBack.items.length > 0"
                      v-model="data.FeedBack"
                      :current-lang="currentLang"
                      :lang="currentLang"                     

                  />
                </template>

                <template v-if="item === 'aboutUs'">
                  <div v-if="data?.aboutUs" class="my-2">
                    <span><v-icon>mdi-comment-account-outline</v-icon></span> :
                    <span class="font-weight-bolder">{{
                      localI18n.t("about_us")
                    }}</span>
                    <div class="col-md-12 mb-2">
                      <pre
                        v-if="data?.aboutUs"
                        class="my-0"
                        v-html="trancateTxts"
                        :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                        :dir="getTextDirectionFromContent(data.aboutUs)"
                        :style="{
                          textAlign: getTextAlignFromContent(data.aboutUs),
                        }"
                      />
                      <v-btn
                        v-if="
                          data?.aboutUs?.length > 200 ||
                          data?.aboutUs?.split('<div>')?.length > 3
                        "
                        class="ms-n4"
                        color="primary"
                        text
                        @click="isTruncate = !isTruncate"
                      >
                        {{
                          isTruncate
                            ? localI18n.t("view_more")
                            : localI18n.t("view_less")
                        }}
                      </v-btn>
                    </div>
                  </div>
                </template>

                <template
                  v-else-if="
                    item === 'video_single' &&
                    !!data?.video_single?.videos?.length > 0
                  "
                >
                  <v-card
                    v-for="(item, i) in data.video_single.videos"
                    :key="i"
                    class="transparent"
                    flat
                    style="max-width: 100%"
                  >
                    <v-card-title
                      :class="{ 'blue--text clickable': item.link }"
                      :href="fixLink(item.link)"
                      :tag="item.link ? 'a' : 'div'"
                      class="pa-2 text-break"
                      target="_blank"
                      v-text="item.title"
                      :dir="getTextDirectionFromContent(item.title)"
                      :style="{
                        textAlign: getTextAlignFromContent(item.title),
                      }"
                    />
                    <video
                      v-if="isDirectVideo(item.url)"
                      :src="item.url"
                      controls
                      style="max-width: 100%; height: auto; width: 100%;"
                    ></video>
                    <iframe
                      v-else
                      :src="item.url"
                      style="max-width: 100%; height: auto; width: 100%;"
                      frameborder="0"
                      allowfullscreen
                    ></iframe>
                    <pre
                      v-html="item.description"
                      :dir="getTextDirectionFromContent(item.description)"
                      :style="{
                        textAlign: getTextAlignFromContent(item.description),
                      }"
                    />
                  </v-card>
                </template>

                <div
                  v-else-if="
                    item === 'video_gallery' &&
                    !!data?.video_gallery?.[0]?.images?.length > 0
                  "
                  class="d-flex flex-column"
                >
                  <div
                    v-for="(src, i) in data?.video_gallery?.[0]?.images"
                    :key="i"
                  >
                    <v-card-title
                      :href="!!src.link ? src.link : null"
                      :tag="!!src.link ? 'a' : 'div'"
                      class="pa-2"
                      target="_blank"
                      v-html="src.title"
                      :dir="getTextDirectionFromContent(src.title)"
                      :style="{
                        textAlign: getTextAlignFromContent(src.title),
                      }"
                    />
                  <video
                    v-if="isDirectVideo(src.url || src.file_link)"
                    :src="src.url || src.file_link"
                    controls
                    style="max-width: 100%; height: auto; width: 100%;"
                  ></video>
                  <iframe
                    v-else
                    :src="src.url || src.file_link"
                    style="max-width: 100%; height: auto; width: 100%;"
                    frameborder="0"
                    allowfullscreen
                  ></iframe>
                    <v-card-text
                      v-show="!!src.description"
                      v-html="src.description"
                      :dir="getTextDirectionFromContent(src.description)"
                      :style="{
                        textAlign: getTextAlignFromContent(src.description),
                      }"
                    />
                  </div>
                </div>

                <template v-else-if="item === 'photo' && data?.photo?.gallery">
                  <div style="max-width: calc(100% - 24px)" v-if="data?.photo?.gallery">
                    <image-slider
                      v-model="data.photo.gallery"
                      :orientation="resolvedOrientation"
                      :is-slider="resolvedIsSlider"
                    />                                                    
                  </div>
                </template>

                <template
                  v-else-if="item === 'extraFields' && data?.extraFields"
                >
                  <extra-shown v-model="data.extraFields" />
                </template>

                <template
                  v-else-if="
                    item === 'phoneNumber' && data?.phoneNumber?.length > 0
                  "
                >
                  <div>
                    <p
                      v-for="(p, i) in data?.phoneNumber"
                      :key="i"
                      :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                    >
                      <v-icon color="red">mdi-phone-outline</v-icon>
                      :
                      <a
                        :href="`tel:${p.number.replace(/[^\d]/g, '')}`"
                        class="link-tag text-left clickable mx-1"
                        target="_blank"
                        dir="ltr"
                      >
                        {{ p.number.replace(/[^\d\+]/g, "") }}
                      </a>
                      {{ p.text }} {{ p.number.replace(/[\d\^+]/g, "") }}
                    </p>
                  </div>
                </template>

                <template v-else-if="item === 'fax'">
                  <p
                    v-if="data?.fax"
                    class="my-2"
                    :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                    :dir="getTextDirectionFromContent(data.fax)"
                    :style="{
                      textAlign: getTextAlignFromContent(data.fax),
                    }"
                  >
                    <v-icon>mdi-fax</v-icon>
                    : {{ data?.fax }}
                  </p>
                </template>

                <template v-else-if="item === 'location'">
                  <div :class="isCurrentLangRTL ? 'text-right' : 'text-left'">
                    <pre
                      v-if="data?.location"
                      class="d-flex justify-start align-start my-2"
                      :dir="getTextDirectionFromContent(data.location)"
                      :style="{
                        textAlign: getTextAlignFromContent(data.location),
                      }"
                    >
                      <v-icon>mdi-map-marker</v-icon>: {{ data?.location }}
                    </pre>
                  </div>
                </template>

                <template v-else-if="item === 'codePostal'">
                  <p
                    v-if="data?.codePostal"
                    class="my-2"
                    :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                  >
                    <v-icon>mdi-post</v-icon>
                    : {{ data?.codePostal }}
                  </p>
                </template>

                <template v-else-if="item === 'email'">
                  <a
                    :href="`mailto:${data?.email}`"
                    target="_blank"
                    v-if="data?.email"
                  >
                    <p
                      v-if="data?.email"
                      class="my-2 clickable link-tag"
                      :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                    >
                      <span
                        ><v-icon color="red">mdi-email-outline</v-icon></span
                      >
                      : {{ data?.email }}
                    </p>
                  </a>
                </template>
                <template
                  v-else-if="
                    item?.startsWith('audio_') &&
                    data?.audiosGallery?.audios?.length > 0
                  "
                >
                  <v-col cols="12">
                    <v-col cols="12">
                      <v-card
                        v-if="data?.audiosGallery?.audios"
                        width="300"
                        height="auto"
                        :style="{ background: getAudioById(item)?.background }"
                        class="pa-0 my-2 d-flex align-items-center flex-column"
                        :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                      >
                        <v-card-title
                          :style="{ color: getAudioById(item)?.color }"
                          v-if="getAudioById(item)?.ti?.length > 0"
                          >{{ getAudioById(item)?.ti }}</v-card-title
                        >
                        <v-card-subtitle
                          :style="{ color: getAudioById(item)?.color }"
                          class="pa-0"
                          v-if="getAudioById(item)?.desc?.length > 0"
                          >{{ getAudioById(item)?.desc }}</v-card-subtitle
                        >
                        <component
                          v-if="data?.audiosGallery?.audioType"
                          :is="data.audiosGallery.audioType"
                          :file="getAudioById(item).full_path"
                          :link="false"
                          :inf="{
                            ti: getAudioById(item)?.ti,
                            link: getAudioById(item)?.link,
                            title: getAudioById(item)?.title,
                            desc: getAudioById(item)?.desc,
                          }"
                          :image="getAudioById(item)?.image"
                          :title="
                            getAudioById(item).title.length > 0
                              ? getAudioById(item).title
                              : localI18n.t('audio_file')
                          "
                          width="100%"
                          :height="
                            data?.audiosGallery?.audioType == 'newPlayer'
                              ? 280
                              : 150
                          "
                          :flat="true"
                          :audioSound="false"
                          :color="getAudioById(item)?.color"
                          background="transparent"
                        :auto-play="item.autoPlay"

                        />
                      </v-card>
                    </v-col>
                  </v-col>
                </template>

                <template v-else-if="item === 'website'">
                  <p
                    v-if="data?.website"
                    class="my-3 clickable link-tag"
                    :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                    @click="goToUrl(data.website)"
                  >
                    <span><v-icon color="blue">mdi-earth</v-icon></span> :
                    {{ data?.website }}
                  </p>
                </template>
              </template>
            </drag-list>
          </div>
        </div>

        <div
          :style="{ background: data?.pallete?.bodyColor||'linear-gradient(to top left , #006064FF, #03A9F4FF)' }"
          class="social-wrapper"
        >
          <v-row justify="center" no-gutters>
            <v-col
              v-for="(item, index) in thirdOne"
              :key="index"
              class="text-center"
              cols="3"
            >
              <v-btn
                :style="{ background: data?.pallete?.headColor||'linear-gradient(to top left , #00BCD4FF, #2F0743FF)' }"
                class="px-0"
                depressed
                min-width="52"
                x-large
                @click="goToUrl(item.url, item.pattern)"
              >
                <span :src="item.img" 
                    alt="" 
                    class="social-img social-svg-icon"
                    :style="getSocialIconStyle(item.img)"
                    :height="item.svg.toLowerCase()==='svgbasalam'? '22px': isBigSvg(item.svg) ? '29px' : '32px'"
                    :width="item.svg.toLowerCase()==='svgbasalam'? '22px':isBigSvg(item.svg) ? '29px' : '32px'" ></span>
              </v-btn>
            </v-col>

            <v-col v-if="computeFields.length > 0" class="text-center" cols="3">
              <v-menu
                class="overflow-y-auto"
                nudge-top="40"
                right
                style="max-height: 30px !important"
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :style="{ background: data?.pallete?.headColor||'linear-gradient(to top left , #00BCD4FF, #2F0743FF)',
                              color: data?.pallete?.textColor||'#ffffff'

                     }"
                    class="px-0"
                    depressed
                    min-width="52"
                    v-bind="attrs"
                    x-large
                    v-on="on"
                  >
                    <v-icon size="28" :style="{color:data?.pallete?.textColor}">mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list
                  :style="{ background: data?.pallete?.bodyColor||'linear-gradient(to top left , #006064FF, #03A9F4FF)' }"
                  dark
                  min-width="150"
                >
                  <v-list-item
                    v-for="(item, index) in computeFields"
                    :key="index"
                    link
                    @click="goToUrl(item.url, item.pattern)"
                  >
                    <v-list-item-icon>
                      <v-btn dark icon>
                        <span :src="item.img" alt=""
                            class="social-img social-svg-icon"
                            :style="getSocialIconStyle(item.img)"
                            :height="item.svg.toLowerCase()==='svgbasalam'? '22px': isBigSvg(item.svg) ? '29px' : '32px'"
                            :width="item.svg.toLowerCase()==='svgbasalam'? '22px':isBigSvg(item.svg) ? '29px' : '32px'"></span>
                      </v-btn>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <!--                        {{ item.pattern }}-->
                      <v-list-item-title v-text="item.label" :style="{color:data?.pallete?.textColor}"/>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </component>
  </v-responsive>
</template>

<script>
import {
  textDirectionMixin,
  detectLanguage,
  getTextAlign,
} from "@/utilities/textDirection";
import axios from "axios";
import { Bus, debounce } from "@/main";
import localI18n from "@/i18n_local_cardvisit";
import { mapGetters, mapActions } from "vuex";
import {
  mapGeolocateControl,
  mapir,
  mapMarker,
  mapNavigationControl,
} from "mapir-vue";
import { AtomSpinner } from "epic-spinners";
import {
  VFadeTransition,
  VScaleTransition,
  VSlideXTransition,
  VSlideYTransition,
} from "vuetify/lib";
import GallerySlider from "../../../businessPage/components/view/gallerySlider";
import ImageSlider from "../../../../components/Gallery/imageSlider";
import DragList from "../../dragList";
import ExtraShown from "../../../../components/Product/extraShown";
import { setDragging } from "@/utilities/DraggingKeysOrder";
import AudioPlayerCard from "../../../../components/UploadCenter/voiceGallery/components/audio/audioPlayerCard.vue";
import newPlayer from "../../../../components/UploadCenter/voiceGallery/components/audio/newPlayer.vue";
import newPlayer2 from "../../../../components/UploadCenter/voiceGallery/components/audio/newPlayer2.vue";
import LanguageSwitcherList from "../languageswitcherlist.vue";
import PdfPreviewDisplay from "@/view/components/Gallery/PdfPreviewDisplayCell_multilang";
import ConsultationNewShow from "../../../../components/consultationNew/consultationNewShowCell_multilang.vue";
import BFeedbackView from "../../../businessPage/components/view/bFeedbackView_mulilang.vue";
import UniversalQrModal from "../../../../components/UniversalQrModal.vue";


export default {
  name: "visitThemeTwo",
  mixins: [textDirectionMixin],

  components: {
    ExtraShown,
    DragList,
    ImageSlider,
    GallerySlider,
    mapGeolocateControl,
    mapir,
    mapMarker,
    mapNavigationControl,
    AtomSpinner,
    AudioPlayerCard,
    newPlayer,
    newPlayer2,
    LanguageSwitcherList,
    BFeedbackView,
    ConsultationNewShow,
    PdfPreviewDisplay,
    UniversalQrModal,

  },

  props: {
    value: Object,
    orders: Array,
    qrSvgDataUrl: {
      type: String,
      default: "",
    },

  },

  data: () => ({
    showQrDialog:false,
    mainMenu: false,
    langMenu: false,
    langPage: false,
    localI18n,
    showLangDialog: false,
    currentLang: "fa",
    langDataCache: {},
    activeFloating: false,
    expand: true,
    topAction: 24,
    isTruncate: true,
    vcfLoading: false,
    showWelcome: false,
    locationPage: false,
    locLoading: false,
    components: {
      scale: VScaleTransition,
      slideX: VSlideXTransition,
      slideY: VSlideYTransition,
      fade: VFadeTransition,
    },
  }),

  created() {
    // this.$root.$on("mobile-viewer-lang-change", (lang) => {
    //   this.changeLanguage(lang);
    //   this.$forceUpdate();
    // });

    this.$root.$on("lang-data-loaded", ({ lang, data }) => {
      if (this.currentLang === lang) {
        this.applyLangData(lang, data);
      }
    });
    this.$root.$on("fetchDragList", this.setKeys);
  },

  mounted() {
    setTimeout(() => {
      this.setKeys(this.data);
      this.$root.$on("visit-data-updated", (payload) => {
        if (payload?.data?.lang === this.currentLang) return;

        this.data = payload?.data?.data;
        // this.orders = payload.orders;
        this.theme = payload?.data?.theme;
        this.$forceUpdate();
      });
      this.ensureDefaults();
      this.changeLanguage(this.sourceLanguage);
    }, 200);
    if (
      !this.data ||
      !this.data?.pallete ||
      Object.keys(this.data?.pallete).length <= 0 ||
      ["qr.create","auto.create","qr.cardVisit"].includes(this.$route.name)
    ) {
      this.valueComputed.pallete = {
        headColor: "linear-gradient(to top left , #00BCD4FF, #2F0743FF)",
        bodyColor: "linear-gradient(to top left , #006064FF, #03A9F4FF)",
        textColor: "#ffffff",
        borderColor: "#393939",
      };
    }
    if (!this.data) {
      this.valueComputed = { photo: {} };
    } else if (!this.data?.photo) {
      this.valueComputed.photo = {};
    }
    if (
      !this.data?.photo ||
      !this.data?.photo?.headBackground ||
      ["qr.create","auto.create","qr.cardVisit"].includes(this.$route.name)
    )
      this.data.photo.headBackground = "/media/defaults/visitTwoDefault.webp";

    if (!!this.orders.length) this.fixOrders(this.value);
    else this.setKeys(this.value);

    Bus.$on("showMe", (value) => {
      if (this.value?.photo.hasWelcome) {
        this.showWelcome = true;
        this.locationPage = false;
        setTimeout(() => {
          this.locationPage = false;
          this.showWelcome = false;
        }, 5000);
      }
    });
    this.$root.$on("visit-data-updated", (payload) => {
      if (payload?.data?.lang === this.currentLang) return;

      this.data = payload?.data?.data;
      // this.orders = payload.orders;
      // this.theme = payload.data.theme;
      this.$forceUpdate();
    });
    this.ensureDefaults();
    this.changeLanguage(this.defaultLang);
    this.$forceUpdate();
  },
  beforeDestroy() {
    this.$root.$off("fetchDragList");
    this.$root.$off("card-lang-reset");
    this.$root.$off("mobile-viewer-lang-change");
  },

  computed: {
    ...mapGetters("localstorage", [
      "createQrID",
      "alllangs",
      "defaultLang",
      "mainDatalang",
      "currentlanguage",
    ]),
    primaryActionColor() {
      return this.value?.pallete?.bodyColor || "#1976D2";
    },
    resolvedIsSlider() {
    var photoPicSelector =
      this.data &&
      this.data.photo &&
      this.data.photo.PicSelector;

    var mainPicSelector =
      this.data &&
      this.data.PicSelector;

    if (
      photoPicSelector &&
      photoPicSelector.slider != null
    ) {
      return photoPicSelector.slider;
    }

    if (
      mainPicSelector &&
      mainPicSelector.slider != null
    ) {
      return mainPicSelector.slider;
    }

    return true;
  },

  resolvedOrientation() {
    var photoPicSelector =
      this.data &&
      this.data.photo &&
      this.data.photo.PicSelector;

    var mainPicSelector =
      this.data &&
      this.data.PicSelector;

    if (
      photoPicSelector &&
      photoPicSelector.orientation != null
    ) {
      return photoPicSelector.orientation;
    }

    if (
      mainPicSelector &&
      mainPicSelector.orientation != null
    ) {
      return mainPicSelector.orientation;
    }

    return "horizontal";
  },
    layoutPreference() {
      if (this.value.pdfSelector && this.value.pdfSelector.slider) {
        return "slider";
      }
      if (this.value.pdfSelector && this.value.pdfSelector.layout) {
        return this.value.pdfSelector.layout;
      }

      return "list";
    },
    isCurrentLangRTL() {
      const lang =
        this.currentLang || this.defaultLang || this.$i18n?.locale || "fa";
      return this.isRTL(lang);
    },
    currentTextDirection() {
      const lang =
        this.currentLang || this.defaultLang || this.$i18n?.locale || "fa";
      return this.getTextDirection(lang);
    },
    sourceLanguage() {
      return this.defaultLang || "fa";
    },
    data: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    availableLangs() {
      const defaultLang = this.defaultLang || "fa";
      const extraLangs = Array.isArray(this.alllangs) ? this.alllangs : [];
      return [defaultLang, ...extraLangs]
        .filter((lang) => lang && typeof lang === "string")
        .filter((lang, idx, arr) => arr.indexOf(lang) === idx);
    },
    canSaveContact() {
      return (
        (this.data?.phoneNumber?.length > 0 &&
          this.data?.phoneNumber?.[0]?.number) ||
        this.data?.companyNumber
      );
    },
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    trancateTxts() {
      let about = this.data?.aboutUs;

      const more = about?.split("<div>")?.length > 3;

      const text = () => {
        let variable = about?.split("<div>");
        let generatedText = "";
        for (let a = 0; a <= 3; a++) {
          generatedText += "<div>" + variable[a];
        }
        return generatedText;
      };

      about =
        (about.length > 200 || more) && this.isTruncate
          ? (more ? text() : about.slice(0, 100)) + "&hellip;"
          : about;

      return about
        .replace(
          /style="width:604px;height:270px" /gms,
          'style="width:100%;height:auto"',
        )
        .replace(/style="display: block;padding-top: 57%"/gms, "");
      // return about.replace(/<div class="h_iframe-.*<iframe/gms, '<iframe ').replace(/ style="width:604px;height:270px" /gms, '');
    },
    thirdOne() {
      let top = {};

      Object.entries(this.data?.socialMedia)
        .slice(0, 3)
        .forEach(([x, y]) => {
          top[x] = y[0];
        });

      return top;
    },
    computeFields() {
      let extra = [];

      Object.entries(this.data?.socialMedia).forEach(([x, y]) => {
        extra.push(...y);
      });

      Object.values(this.thirdOne).forEach((x) => {
        extra = extra.filter((item) => item !== x);
      });

      return extra;
    },
    getHeaderImg() {
      if (!this.expand) {
        return (
          this.data?.photo?.profile ?? this.data?.photo?.headBackground ?? false
        );
      }

      return this.data?.photo?.headBackground ?? false;
    },
    hasExtra() {
      let arr = this.data?.extraFields.filter(
        (item) => !!item?.name || !!item?.icon || !!item?.value,
      );
      return arr && arr.length > 0;
    },
    draggingKeys: {
      get() {
        return this.orders;
      },
      set(val) {
        this.$emit("update:orders", val);
      },
    },
  },

  watch: {
    currentlanguage: {
      handler(lang) {
        this.changeLanguage(lang);
        this.$forceUpdate();
      },
      deep: true,
      immediate: true,
    },

    "data.langs": {
      handler() {
        this.$forceUpdate();
      },
      deep: true,
    },
    locationPage(val) {
      if (val) {
        this.locLoading = true;
        this.getlatLng();
      }
    },
    "$i18n.locale"(newLocale) {
      const hasLocalLang = this.data?.langs?.other_langs?.some(
        (l) => l.lang === this.currentLang,
      );
      if (!hasLocalLang) {
        this.changeLanguage(newLocale);
      }
    },
    expand(val) {
      if (!val && this.topAction <= 24) {
        setTimeout(() => {
          let head = document.getElementById("header-name");
          this.topAction = head.offsetHeight;
        }, 500);
      }
    },
    value: {
      deep: true,

      handler(val) {
        debounce(() => {
          this.setKeys(val);
        }, 1300);
      },
    },
  },

  methods: {
    ...mapActions("localstorage", [
      "setDraggingKeysOrder",
      "setLangList",
      "setDefaultLang",
      "setCurrentLanguage",
    ]),
         getSocialIconStyle(src) {
    const iconUrl = `url("${src}")`

    return {
      backgroundColor: this.data?.pallete?.textColor || "#ffffff",
      WebkitMaskImage: iconUrl,
      maskImage: iconUrl,
    }
  },
     isDirectVideo(url) {
    if (!url) return false;
    return /\.(mp4|webm|ogg)$/i.test(url.trim());
    },
    isBigSvg(svg) {
    const list = [
      'svgdigikala',
      'svgbasalam',
      'svgsnappshop',
      'svgtechnolife',
      'svgtorob',
      'svgemalls',
      'svgrubika',
      'svgwhatsapp',
      'svgbale',
      'svgeitaa',
      'svgsoroush',
      'svgtelegram',
      'svgviber',
      'svgwechat',
      'svgsheypour',
      'svgdivar',
      'svgaparat',
      'svggap'
    ];
        return list.includes((svg || '').toLowerCase());

  },
    getTextDirectionFromContent(text) {
      if (!text || typeof text !== "string") return this.currentTextDirection;
      const fallbackLang =
        this.currentLang || this.defaultLang || this.$i18n?.locale || "fa";
      return detectLanguage(text, fallbackLang);
    },
    getTextAlignFromContent(text) {
      if (!text || typeof text !== "string")
        return this.isCurrentLangRTL ? "right" : "left";
      const fallbackLang =
        this.currentLang || this.defaultLang || this.$i18n?.locale || "fa";
      return getTextAlign(text, fallbackLang);
    },
    openLangPage() {
      this.langPage = true;
    },

    handleLangChange(newLang) {
      const promise = newLang
        ? this.changeLanguage(newLang)
        : Promise.resolve();
      promise.finally(() => {
        this.langPage = false;
      });

      // this.changeLanguage(newLang).finally(() => {
      //   this.langPage = false;
      // });
    },
    ensureDefaults() {
      if (!this.data) return;
      // pallete
      if (!this.data?.pallete) {
        this.data.pallete = {
          headColor: "linear-gradient(to top, #AA7630FF, #EBCB63FF)",
          bodyColor: "linear-gradient(to top right, #AA7630FF, #EBCB63FF)",
          textColor: "#ffffff",
          borderColor: "#393939",
        };
      }
      // photo
      if (!this.data.photo) this.data.photo = {};
      // if (!this.data.photo.headBackground) {
      //   this.data.photo.headBackground =
      //     "/media/defaults/visitFirstDefault.webp";
      // }
      if (!this.data?.photo?.transition) {
        this.data.photo.transition = "scale";
      }
      // langs
      if (!this.data?.langs) {
        this.data.langs = { source_lang: "fa", other_langs: [] };
      }
    },

    internalLangChange(lang) {
      // if (lang === this.currentLang) {
      //   return;
      // }
      this.$root.isTranslating = true;
      this.changeLanguage(lang);
    },

    syncInitialLang() {
      // if (this.data.langs?.other_langs?.length > 0) {
      //   const firstLang = this.data.langs.other_langs[0].lang;
      //   this.changeLanguage(firstLang);
      // } else {
      this.changeLanguage(
        this.sourceLanguage || this.defaultLang || this.$i18n.locale,
      );
      // }
    },

    changeLanguage(newLang) {
      if (!newLang || newLang === this.currentLang) {
        this.$root.isTranslating = false;
        return;
      }
      const selectlang =
        typeof newLang === "string"
          ? newLang
          : (Array.isArray(newLang) ? newLang[0] : newLang)?.lang || "fa";
      if (!selectlang) {
        this.$root.isTranslating = false;
        return;
      }
      this.$root.isTranslating = true;
      if (selectlang === this.defaultLang) {
        this.data = this.mainDatalang?.data?.data;
        this.localI18n.locale = selectlang;
        this.$root.isTranslating = false;
      } else {
        this.$api
          .get(`/langData?id=${this.createQrID}&lang=${selectlang}`)
          .then((res) => {
            // const data = res?.data?.data;
            // const { data, theme, orders } = QrDataFormatter.unpack(res.data);
            // this.data = res.data.data;
            // this.theme = res.data.theme;
            // this.orders = orders;

            //for data commeit
            // if (this.data === null || this.data === undefined) {
            //   this.changeLanguage(this.defaultLang || this.sourceLanguage);
            //   this.$toast.warning(localI18n.t("errors.service_unavailable"));
            //   return;
            // }
            this.$emit("input", res?.data?.data?.data);

            this.$root.$emit("mobile-viewer-updated", {
              // orders: res.data.data.orders,
              theme: res?.data?.data?.theme,
              data: res?.data?.data?.data,
              lang: newLang,
            });
            // this.$root.$emit("mobile-viewer-lang-change", selectlang);
            this.setCurrentLanguage(selectlang);

            //new change
            this.data = res.data?.data?.data;
            // this.theme = res.data.data.theme;
            // this.orders = res.data.data.orders;
            //  this.langDataCache[newLang] = data;

            this.applyLangData(newLang, this.data);
          })
          .catch(() => {
            //   this.changeLanguage(this.sourceLanguage);
          })
          .finally(() => (this.$root.isTranslating = false));
      }
    },

    applyLangData(lang, data) {
      this.data = { ...data };
      this.ensureDefaults();
      this.currentLang = lang;
      this.localI18n.locale = lang;
    },
    show() {
      this.showconncet = !this.showconncet;
      Bus.$emit("showconnect", this.showconncet);
    },
    getAudioById(itemId) {
      const index = parseInt(itemId.replace("audio_", ""));
      return this.data?.audiosGallery?.audios?.[index] || {};
    },

    openMap() {
      let agent = window.navigator.userAgent;
      let type = "https://www.google.com/maps/@";

      if (agent.toLowerCase().search("android") > 0) {
        type = "geo:";
      } else if (
        agent.search("iPad") > 0 ||
        agent.search("iPhone") > 0 ||
        agent.search("iPod") > 0
      ) {
        type = "maps:";
      }

      window.open(
        `${type}${this.data?.coordinates?.[1]},${this.data?.coordinates?.[0]}?q=${this.data?.coordinates?.[1]},${this.data?.coordinates?.[0]}`,
        "_blank",
      );
    },
    goToUrl(url, pattern = null) {
      let setUrl = "";
      const emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;

      if (!url.startsWith("http")) {
        if (emailRegex.test(url)) setUrl = "mailto:";
        else if (pattern)
          setUrl = pattern.startsWith("http") ? pattern : "https://" + pattern;
        else setUrl = "https://";
      }

      let a = document.createElement("a");
      a.setAttribute("href", setUrl + url);
      a.setAttribute("target", "_blank");
      a.click();
    },
    getlatLng() {
      axios({
        method: "GET",
        baseURL: "https://map.ir/reverse",
        params: {
          lat: this.data.coordinates[1],
          lon: this.data.coordinates[0],
        },
        timeout: 15000,
        headers: {
          "x-api-key":
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.data.address = response?.data?.address;
        })
        .finally(() => (this.locLoading = false));
    },
    getVcf() {
      this.vcfLoading = true;

      const info = {
        fax: undefined,
        email: undefined,
        visitName: undefined,
        organizationName: undefined,
        subOrgan: undefined,
        userName: undefined,
        workField: undefined,
        phoneNumber: undefined,
        companyNumber: undefined,
        location: undefined,
        city: undefined,
        photo: undefined,
        codePostal: undefined,
        province: undefined,
        country: undefined,
        website: undefined,
        socialMedia: undefined,
        aboutUs: undefined,
        address: undefined,
      };

      Object.keys(info).forEach((x) => {
        info[x] = this.value[x];
      });
      axios
        .post(process.env.VUE_APP_VCF, info)
        .then((x) => {
          var a = document.createElement("a"); //Create <a>
          a.href = "data:text/vcard;charset=utf-8;base64," + x.data; //Image Base64 Goes here
          a.download = `${info.userName}.vcf`; //File name Here
          a.click(); //Downloaded file
        })
        .finally(() => (this.vcfLoading = false));
    },
    extraIsLink(item) {
      return item.link && item.link.length > 0;
    },
    fixLink(link) {
      return link.startsWith("http") ? link : "https://" + link;
    },
    fixOrders(val) {
      // Get the keys from the input object
      const keys = Object.keys(val);

      // Extract the names from the draggingKeys array
      const mapOrder = this.draggingKeys.map((item) => item.name);

      // Filter keys to include only those present in mapOrder
      const result = keys.filter((item) => mapOrder.includes(item));

      // Sort the filtered keys based on their order in mapOrder
      const sortedKeys = result.sort(
        (a, b) => mapOrder.indexOf(a) - mapOrder.indexOf(b),
      );

      // Update draggingKeys with the sorted keys
      this.draggingKeys = sortedKeys.map((item) => ({ name: item }));
    },
    setKeys(val = this.value) {
        if (!this.data) return;

      let keys = setDragging(val, this.draggingKeys || []);
      if (val?.audiosGallery?.audios?.length > 0) {
        const audioKeys = val.audiosGallery.audios.map((_, i) => ({
          name: `audio_${i}`,
        }));
        keys = [
          ...keys.filter((k) => !k.name.startsWith("audio_")),
          ...audioKeys,
        ];
      }

      const hasGallery = val?.photo?.gallery && val.photo.gallery.length > 0;
      const hasProfileOrBg = !!(
        val?.photo?.profile || val?.photo?.headBackground
      );

      if (
        (hasGallery || hasProfileOrBg) &&
        !keys.some((k) => k.name === "photo")
      ) {
        keys.push({ name: "photo" });
      }

      this.draggingKeys = keys.filter((k) => k.name !== "audiosGallery");

      keys = keys.filter(
        (item) => item.name !== "langs" && item.name !== "language",
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.expand-btn-enter-active,
.expand-btn-leave-active,
.fade-head-img-enter-active,
.fade-head-img-leave-active {
  transition: all 0.3s;
}

.expand-btn-enter, .expand-btn-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: rotate(720deg);
  opacity: 0.3;
}

.fade-head-img-enter,
.fade-head-img-leave-to {
  transform: scale(0.5);
  opacity: 0.3;
}
.content-holder.contracted .header-img-container {
  right: 15px;
  left: auto;
}
.content-holder {
  padding-top: 92px;

  &.contracted {
    .header-img-container {
      border-radius: 50% !important;
      top: 15px;
      // right: 15px;
          inset-inline-end: 15px;

      height: 60px;
      width: 60px;
    }

    .sticky-name-holder {
      padding-right: 75px;
      top: 0;

      .v-btn {
        align-self: flex-start;
      }

      &::before,
      &::after {
        top: unset;
        bottom: 0;
      }

      &::before {
        -webkit-transform: skewY(-37deg) translateY(32%) translateZ(-2px);
        transform: skewY(-37deg) translateY(32%) translateZ(-2px);
      }
    }

    .btn-action {
      transform: translateY(-50%);
      //top: 76px;
    }

    .main-wrapper {
      background: white;
      padding: 32px 12px 12px;
      animation: main-anm-in 0.3s;
      animation-fill-mode: both;
      animation-delay: 0.3s;
    }

    .social-wrapper {
      animation: social-wrapper-anm-in 0.3s ease-out;
      animation-fill-mode: both;
    }

    .social-wrapper > .row > .col {
      animation: social-anm-in 0.3s ease-out;
      animation-fill-mode: both;
    }
  }

  &.expanded {
    .main-wrapper {
      display: none;
    }

    .btn-action {
      animation: btn-action-anm 5s;
      animation-delay: 2s;
      animation-iteration-count: infinite;
    }
  }

  .header-img-container {
    overflow: hidden;
    transition: all 0.3s;
    position: absolute;
    top: 0;
     right: 25px;
      left: auto;
    z-index: 3;
    // inset-inline-end: 25px; /* این ویژگی در RTL تبدیل به right و در LTR تبدیل به left می‌شود */
  width: calc(100% - 25px);
    height: calc(100% - 95px);
    max-height: calc(100% - 95px);
  }

  .header-img-bg {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 100%;
    height: 100%;
    object-fit: cover;

    .bg-filter {
      position: absolute;
      inset: -4px;
      background-size: cover;
      filter: blur(1.8px) brightness(1.3) opacity(0.8);
    }

    img {
      position: relative;
      z-index: 2;
      max-width: 100%;
      max-height: 100%;
    }
  }

  .sticky-name-holder {
    display: flex;
    justify-content: space-between;
    transition: all 0.3s;
    position: absolute;
    top: calc(100% - 95px);
    width: 100%;
    padding: 8px;
    z-index: 2;
    transform-style: preserve-3d;

    > * {
      position: relative;
      z-index: 3;
    }

    &:after {
      content: "";
      top: 0;
      right: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 1;
      background: inherit;
    }

    &::before {
      transition: all 0.3s;
      content: "";
      top: 0;
      position: absolute;
      right: 0;
      width: 25px;
      height: 30px;
    }

    &::before {
      background: inherit;
      -webkit-transform: skewY(37deg) translateY(-32%) translateZ(-2px);
      transform: skewY(37deg) translateY(-32%) translateZ(-2px);
    }

    .v-btn {
      align-self: center;
    }
  }

  .btn-action {
    transition: all 0.3s;
    z-index: 3;
    border: 3px solid white;
    right: 55px;
  }

  .main-wrapper,
  .social-wrapper {
    max-width: calc(100% - 25px);
    margin-inline-end: auto;
  }

  .main-wrapper {
    overflow-y: auto;
    opacity: 0;
    transform: translateY(100px);
    width: 100%;
    min-height: 400px;
    height: calc(80vh - 184px);
    max-height: 655px;
    border-right: 1px solid rgba(0, 0, 0, 0.2);
  }

  .social-wrapper {
    padding: 8px;
    position: relative;
    z-index: 1;
    opacity: 0;
    transform: translateY(100%);
  }

  .social-wrapper > .row > .col {
    opacity: 0;
    transform: translateY(100%);
  }

  .social-wrapper > .row > .col:first-child {
    animation-delay: 0.3s;
  }

  .social-wrapper > .row > .col:nth-child(2) {
    animation-delay: 0.45s;
  }

  .social-wrapper > .row > .col:nth-child(3) {
    animation-delay: 0.6s;
  }

  .social-wrapper > .row > .col:nth-child(4) {
    animation-delay: 0.75s;
  }
}

.social-img {
  width: 30px;
  min-width: 30px;
  max-width: 30px;
}

@keyframes main-anm-in {
  from {
    opacity: 0;
    transform: translateY(100px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes social-wrapper-anm-in {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes social-anm-in {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes btn-action-anm {
  0% {
    transform: scale(1) translateY(0) rotate(0);
  }
  5% {
    transform: scale(1.3) translateY(10px) rotate(15deg);
  }
  10% {
    transform: scale(1.4) translateY(15px) rotate(-15deg);
  }
  14% {
    transform: scale(0.8) translateY(-10px) rotateY(-180deg);
  }
  20% {
    transform: scale(1) translateY(0) rotate(0);
  }
}

pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
}

iframe {
  border: none;
  border-radius: 8px;
}

.link-tag,
.link-tag .v-icon {
  color: #0985d2;
  cursor: pointer;
}

.link-tag:hover,
.link-tag:hover .v-icon {
  color: #33a9f1;
}
.box{
  width: 97% !important;
}

.social-svg-icon {
  display: inline-block;
  width: 30px;
  height: 30px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;

  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  -webkit-mask-size: contain;

  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
}
.qr-floating-btn {
  position: absolute;
  top: 14px;
  left: 14px;
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.9) !important;
}

</style>
